import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

import { environment } from '../../../environments/environment';
import { ServicesService } from '../../services/services.service';

@Component({
  selector: 'app-virtual-orders',
  templateUrl: './virtual-orders.component.html',
  styleUrls: ['./virtual-orders.component.css']
})
export class VirtualOrdersComponent implements OnInit {
  apiUrl;
  isViewOrderInfo:any=false;

  //variable for static data mentioned below
  fields:any=[];
  fields2:any=[];
  listData:any=[];
  backOrder:any=[];
  productList:any=[];
  cid:string;
  clientName:string;
  order_id:any = "abc";
  back_order_arr:any;
  showloader = false;

  spinLoader = {
    filter : false,
    delete : []
  };

  isListData=true;
  isOnePage=true;
  backDiv=false;
  isNoDataList=false;
  tokenStatus:any;
  cname:any;

  constructor(private route: ActivatedRoute, private _services: ServicesService, private router: Router) {
    this.route.queryParams.subscribe(params=>{

      this.cid = params['cid'];
      this.cname = params['cname'];

    })
  }

  ngOnInit() {
    this.apiUrl = environment.apiUrl;
    //if client id is set in url form clientDashBoard...
    if(this.cid != undefined){
      // //console.log(this.cid);
      this.clientName=this.cname;
      this.backDiv=true;
    }

    this.getPageRequest();
    this.getOrderProjectList();

    this.fields = [
      {
        'field' : 'order_no_unique',
        'title' : 'Order No',
        'width' : '25%',
        'code'  : true,
        'sort'  : true
      },
      {
        'field' : 'client_name',
        'title' : 'Client Name',
        'width' : '25%',
        'code'  : true,
        'sort'  : true
      },
      {
        'field' : 'order_date',
        'title' : 'Order Date',
        'width' : '20%',
        'code'  : false,
        'sort'  : false
      },
      {
        'field' : 'order_status',
        'title' : 'Order Status',
        'width' : '15%',
        'code'  : false,
        'sort'  : false
      }
    ]

    this.fields2 = [
      {
        'field' : 'component_name',
        'title' : 'Component Name',
        'width' : '67%',
        'code'  : true,
        'sort'  : false
      },
      {
        'field' : 'quantity',
        'title' : 'Quantity',
        'width' : '33%',
        'code'  : false,
        'sort'  : false
      }
    ]
  }//ngInit end here
  config = {
    displayKey:"project_name", //if objects array passed which key to be displayed defaults to description,
    search:true, //enables the search plugin to search in the list,
    limitTo:5
  }

  resetSearchField(){
    this.spinLoader['filter'] = true;
    this.searchFields=[''];
    this.searchProjectId='';
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }


  sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
    'field' : '',
    'type'  : ''
  };

  sortBy(field, event){
    this.spinLoader['filter'] = true;
    this.oldField = (this.oldField != field) ? this.oldField : field;

    if(typeof this.oldField !== 'undefined'){
      ////console.log(document.getElementById('fa-'+this.oldField));

      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
    }

    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
    }

    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
    };

    this.getPageRequest();
  }

  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  searchFields= [];
  pages: any;
  editData: Object = {};
  previousPage(){
    if(this.currentPage == 1){
      return;
    }
    this.spinLoader['filter'] = true;
    this.currentPage = this.currentPage -1;
    this.getPageRequest();
  }

  nextPage() {
    this.spinLoader['filter'] = true;
    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    this.getPageRequest();
  }

  changePage(){
    this.spinLoader['filter'] = true;
    this.currentPage = this.currentPage;
    this.getPageRequest();
  }

  getPages(n){
    if(n>1){
      this.isOnePage=true;
    }else{
      this.isOnePage=false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
  routePath:string;

  getPageRequest(){
    this.routePath  = 'get-virtual-order-list-web';
    switch(this.routePath){
      case 'get-virtual-order-list-web':{
        var data = {
          client_id: this.cid,
          page  : this.currentPage,
          search: {
            'client_name' : this.searchFields['client_name'],
            'order_no_unique': this.searchFields['order_no_unique'],
          },
          sort  : this.sortingData,
          project_order_id:this.searchProjectId?this.searchProjectId:'',
        };
      }
        break;
    }
    const token    = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      this._services.checkToken(result.status);
      this.spinLoader['filter'] = false;
      this.isListData=false;
      this.listData = result.result;
      //console.log(this.listData );
      this.listData==''?this.isNoDataList=true:this.isNoDataList=false;;

      if(result.backOrder){
        this.backOrder = result.backOrder;
      }

      // //console.log(this.backOrder);
      this.paginate = result.paginate;
      this.currentPage = result.paginate.current_page;
      this.total = result.paginate.total;
      if(result.paginate.current_page > result.paginate.last_page){
        this.currentPage = result.paginate.last_page;
      }
      this.getPages(this.paginate.last_page);

    });
    return true;
  }
  status:any;
  total:any;

  //this function delete Order(soft delete);
  deleteOrder(id,orderNo){
    $('#deleteSpinner_'+id).removeClass('hidden');
    swal({
      title: 'Are you sure?',
      text: 'You want to Delete Order No: '+orderNo,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#163862',
      cancelButtonColor: 'rgb(245, 54, 92)',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if(result.value==true){
        this.routePath = 'delete-virtual-order';
        let token = this._services.getToken();

        var data = {
          client_id: this.cid,
          order_id: id,
          page  : this.currentPage,
          search: {
            'client_name' : this.searchFields['client_name'],
            'order_no_unique': this.searchFields['order_no_unique'],
          },
          sort  : this.sortingData
        };
        this._services.postRequest(data,this.routePath,token).subscribe((data: any) => {
          if(this._services.checkToken(data.status)){
            swal({
              title: 'Deleted.',
              text: data.message,
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: 'rgb(17, 205, 239)',
              cancelButtonColor: 'rgb(245, 54, 92)',
              confirmButtonText: 'Yes'
            }).then(() => {
              $('#deleteSpinner_'+id).addClass('hidden');
              this.listData = data.result;
              this.paginate = data.paginate;
              this.getPages(this.paginate.last_page);
            });
          }
        });
      }else{
        $('#deleteSpinner_'+id).addClass('hidden');
      }
    });
  }

  //called when back btn pressed.
  showOrderList(){
    this.isViewOrderInfo = false;
  }
  //this function called when view particular order.
  showOrderInfo(id){
    this.order_id = id;
    this.isViewOrderInfo = true;
    this.spinLoader['filter']=true;
    this.routePath = 'get-virtual-order-products';
    let token = this._services.getToken();
    var data = {
      order_id: id,
    };
    this._services.postRequest(data,this.routePath,token).subscribe((data: any) => {
      this.spinLoader['filter']=false;
      this.productList=[];
      for(let element in data.result){
        this.productList.push(data.result[element]);
      }
      // //console.log(this.productList);
    })
  }


  routeData;
  orderProjectList:any;
  getOrderProjectList(){
    let data;
    this.routeData = 'get-project-virtual-order-list';

    switch(this.routeData){

      case 'get-project-virtual-order-list':{
        data = {
          page  : this.currentPage,
          search: {
            'project_name' : this.searchFields['project_name'],
          }
        };
        break;
      }
    }
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if(this._services.checkToken(result.status)){
        // //console.log(result.result);
        this.orderProjectList = result.result;
        // //console.log(this.orderProjectList);
      }
    });

    return true;
  }

  searchProjectId:any='';
  searchProjectOrder(event){
    this.searchProjectId = event.value[0].id?event.value[0].id:1;
    // this.getPageRequest();
  }


  moveOrder(virtual_order_id,i){
    // this.listData[i].moved = 1;
    let virtual_order_data = {
      virtual_order_id : virtual_order_id
    };
    this.showloader=true;
    let routeUrl = 'move-client-virtual-order';
        this._services.requestCreator(virtual_order_data,routeUrl,this._services.getToken()).subscribe((data: any) => {
          //console.log("data",data);
          if(this._services.checkToken(data.status)){
            if(data.status == '200'){

              this.showloader=true;
              swal({
                title: 'Order moved Successfully',
                text: data.message,
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {

                this.showloader=true;
                //console.log("Cid : "+this.cid+" cname "+this.cname);

                // this.routerouter.navigate('/client-virtual-orders-list', {queryParams:{'cid':this.cid,'cname':this.cname}});
                this.router.navigate(['/client-virtual-orders-list'], {queryParams:{'cid':this.cid,'cname':this.cname}})

                  window.location.reload();


              })
            } else{
              this.listData[i].moved = 0;
              this.showloader=false;
            }
          }
        });
  }
}
